export const airports = [
  {
    "id" : 2000001,
    "name" : "فرودگاه امام خمینی",
    "borderId" : 250001,
    "coordinates" : [
      51.0960229,
      35.4506022
    ]
  },
  {
    "id" : 2000002,
    "name" : "فرودگاه مشهد",
    "borderId" : 250002,
    "coordinates" : [
      59.61009979248047,
      36.24904972605289
    ]
  },
  {
    "id" : 2000003,
    "name" : "فرودگاه اصفهان",
    "borderId" : 250003,
    "coordinates" : [
      51.78302764892579,
      32.78633439770585
    ]
  },
  // {
  //   "id" : 500002,
  //   "name" : "پایانه مرزی تمرچین",
  //   "coordinates" : [
  //     45.0551033,
  //     36.695952
  //   ]
  // },
  // {
  //   "id" : 300001,
  //   "name" : "پایانه مرزی باشماق",
  //   "coordinates" : [
  //     45.9932327,
  //     35.6346976
  //   ]
  // },
  {
    "id" : 750002,
    "name" : "فرودگاه ساری",
    "borderId" : 750002,
    "coordinates" : [
      53.21880340576172,
      36.65850456897558
    ]
  },
  {
    "id" : 750005,
    "name" : "فرودگاه شیراز",
    "borderId" : 750005,
    "coordinates" : [
      52.62107849121094,
      29.547774558769333
    ]
  },
  {
    "id" : 750006,
    "name" : "فرودگاه تبریز",
    "borderId" : 750006,
    "coordinates" : [
      46.30256652832032,
      38.125374473531586
    ]
  },
  {
    "id" : 750007,
    "name" : "فرودگاه فارس",
    "borderId" : 750007,
    "coordinates" : [
      54.40841674804688,
      27.680031778895607
    ]
  },
  {
    "id" : 750009,
    "name" : "فرودگاه بندرعباس",
    "borderId" : 750009,
    "coordinates" : [
      56.37608528137208,
      27.202579597457152
    ]
  },
  {
    "id" : 850001,
    "name" : "فرودگاه کيش",
    "borderId" : 850001,
    "coordinates" : [
      53.95505905151368,
      26.51681688238852
    ]
  },
  {
    "id" : 750004,
    "name" : "فرودگاه بوشهر",
    "borderId" : 750004,
    "coordinates" : [
      50.85897445678712,
      28.96369333786114
    ]
  }
]